module.exports = __webpack_public_path__ + "static/media/kaushalbros.d8a1e12d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Artist/static/images/kaushalbros.jpg
// module id = 111
// module chunks = 1